// extracted by mini-css-extract-plugin
module.exports = {"header":"Main_header__pNbYw","maxWidth":"Main_maxWidth__1J_Mx"};